'use strict';

var pill = require('../../../../../../../../../../_virtual/pill2.cjs');

(function (exports) {

	exports.PillSizes = void 0;
	(function(PillSizes) {
	    PillSizes["xsmall"] = "xsmall";
	    PillSizes["small"] = "small";
	    PillSizes["medium"] = "medium";
	})(exports.PillSizes || (exports.PillSizes = {}));
	
} (pill.__exports));
//# sourceMappingURL=pill.cjs.map
